/*
 * 22.10 Eslem – ürün kartında renk karesine basınca ürüne gitmeden kart o renge döner (Zara gibi).
 * Yeni renk kartı /products/<handle>?view=kart (templates/product.kart.liquid) ile alınır ve kartın yerine konur;
 * böylece görsel, isim, fiyat, renk kareleri, kalp (favoriler.js) ve çanta (hizli-ekle.js) o renge ait olur.
 * Görsele / isme basınca seçili rengin ürün sayfasına gidilir. Hata olursa normal bağlantı gibi ürüne gider.
 */
(function () {
  if (window.kartRenkKur) return;
  window.kartRenkKur = true;

  const kok = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const onbellek = {};
  const handleAl = (a) => {
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };
  const kartGetir = (h) => onbellek[h] || (onbellek[h] = fetch(kok + 'products/' + encodeURIComponent(h) + '?view=kart')
    .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
    .catch((e) => { delete onbellek[h]; throw e; }));

  // Parmak / fare kareye gelince önceden yükle (geçiş anında olsun)
  const onYukle = (e) => {
    const a = e.target.closest && e.target.closest('.kart-renk');
    if (!a || a.classList.contains('is-secili')) return;
    const h = handleAl(a); if (h) kartGetir(h).catch(() => {});
  };
  document.addEventListener('pointerenter', onYukle, true);
  document.addEventListener('touchstart', onYukle, { passive: true, capture: true });

  document.addEventListener('click', async (e) => {
    const a = e.target.closest('.kart-renk');
    if (!a) return;
    const kart = a.closest('product-block');
    const h = handleAl(a);
    if (!kart || !h) return; // kart dışında ise normal bağlantı
    e.preventDefault();
    e.stopPropagation();
    if (a.classList.contains('is-secili')) return;
    kart.classList.add('is-renk-yukleniyor');
    try {
      const html = await kartGetir(h);
      const t = document.createElement('template');
      t.innerHTML = html.trim();
      const yeni = t.content.querySelector('product-block');
      if (!yeni) throw new Error('kart yok');
      // Favoriler sayfasındaki işaret korunur
      if (kart.dataset.fvHandle) yeni.dataset.fvHandle = h;
      // 23.10: bazı kayan alanlarda kart genişliği görsele göre belirleniyor → yeni renk büyük/küçük görünmesin,
      // eski kartın ölçüsü korunur (fark varsa kilitlenir)
      const eskiG = kart.getBoundingClientRect().width;
      const eskiGorsel = kart.querySelector('.image-cont');
      const eskiGH = eskiGorsel ? eskiGorsel.getBoundingClientRect().height : 0;
      kart.replaceWith(yeni);
      const olcuKoru = () => {
        if (!eskiG || !yeni.isConnected) return;
        if (Math.abs(yeni.getBoundingClientRect().width - eskiG) > 2) { yeni.style.width = eskiG + 'px'; yeni.style.maxWidth = '100%'; yeni.style.flexShrink = '0'; }
        const yg = yeni.querySelector('.image-cont');
        if (yg && eskiGH && Math.abs(yg.getBoundingClientRect().height - eskiGH) > 2) { yg.style.aspectRatio = eskiG + ' / ' + eskiGH; yg.style.overflow = 'hidden'; }
      };
      olcuKoru(); requestAnimationFrame(olcuKoru);
      yeni.querySelectorAll('.image-cont img').forEach((img) => img.addEventListener('load', olcuKoru, { once: true }));
      // Tembel yüklenen görseller
      yeni.querySelectorAll('img[data-src]').forEach((img) => { if (!img.getAttribute('src')) img.src = img.dataset.src; });
      if (window.hosFavoriler) window.hosFavoriler.boya();
      document.dispatchEvent(new CustomEvent('kart:renk-degisti', { detail: { handle: h, kart: yeni } }));
    } catch (err) {
      window.location.href = a.href;
    } finally {
      kart.classList.remove('is-renk-yukleniyor');
    }
  });
})();
